export const LogoMark = ({ className = "h-8 w-8 text-gold" }) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M16 4L26 24H6L16 4Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M6 28C10 28 12 26 16 26C20 26 22 28 26 28"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const LogoFull = ({ compact = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark className={compact ? "h-7 w-7 text-gold" : "h-8 w-8 text-gold"} />
    <span className="whitespace-nowrap font-serif text-base tracking-[0.18em] uppercase text-ivory">
      Velierul <span className="text-gold">Hope</span>
    </span>
  </span>
);
